import { useSyncExternalStore } from "react";

/**
 * Mobilní breakpoint (spec §74): pod 768px se UI přepíná do fokusované
 * mobilní podoby (přehled / rozhodnutí / Jarvis) — desktop command center
 * se na telefon necpe.
 */
const query = typeof window !== "undefined" ? window.matchMedia("(max-width: 767px)") : null;

export function useIsMobile(): boolean {
  return useSyncExternalStore(
    (listener) => {
      query?.addEventListener("change", listener);
      return () => query?.removeEventListener("change", listener);
    },
    () => query?.matches ?? false,
  );
}
